import React from 'react';
import { Outlet } from 'react-router';

const IscLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default IscLayout;
